module.exports = __webpack_public_path__ + "img/chest-10.e0ac5fb8.png";